// extracted by mini-css-extract-plugin
export default {"root":"pZU5h","traded":"_3sJNF","icon":"_3vRjV","warning":"_1lxL9"};